import {ColumnObject, ColumnObjectType} from '../global/CustomDataTable';
import {getColumn, getFilter, Nullable, sortColumn} from './Global';
import {FilterMatchMode, FilterOperator} from 'primereact/api';
import React from 'react';
import {types} from 'sass';


export interface Measure {
    'massnahme_id': string,
    'project_id': string,
    'massnahme_type_name': string,
    'massnahme_type_id': number,
    'umsetzung_type_id': number,
    'zeitraum_type_id': number,
    'name': string,
    'bwv_lf_nr': string,
    'bwv_sub_lf_nr': string,
    'bwv_stand': string,
    'plan_name': string,
    'plan_stand': string,
    'plan_stand_datum': Nullable<Date>,
    'pfa_pgv_name': string,
    'pfa_pgv_stand': string,
    'pfa_pgv_stand_start': number,
    'pfa_pgv_stand_ende': number,
    'pfa_pgv_status_id': string,
    'pfa_pgv_datum': Nullable<Date>,
    'flaechenbezug_type_id': string,
    'flaechenbezug_type_name': string,
    'start_datum_soll': Nullable<Date>,
    'start_datum_ist': Nullable<Date>,
    'ende_datum_soll': Nullable<Date>,
    'ende_datum_ist': Nullable<Date>,
    'flurstueck': any[]
}


export const getColumnsMeasure = (t: any, showParcelInfo: boolean) => {
    const temp = [];

    temp.push(
        getColumn(t, 'pfa_pgv_name', 'projectMasterData:measures.columns.'),
        getColumn(t, 'pfa_pgv_stand', 'projectMasterData:measures.columns.', true, false),
        getColumn(t, 'pfa_pgv_datum', 'projectMasterData:measures.columns.', true, false, ColumnObjectType.Date, t('dateformat')),
        getColumn(t, 'bwv_lf_nr', 'projectMasterData:measures.columns.'),
        getColumn(t, 'bwv_sub_lf_nr', 'projectMasterData:measures.columns.'));

    if (showParcelInfo) {
        temp.push({
            field: 'parcel',
            header: t('globalData:global.anzahlflurstuecke'),
            body: (rowData: any) => {
                if (rowData['flurstueck']) {
                    return rowData['flurstueck'][0] === null ? 0 : rowData['flurstueck'].length;
                }
            },
            sortFunction: sortColumn,
            display: false
        },);
    }

    temp.push(
        getColumn(t, 'massnahme_type_name', 'projectMasterData:measures.columns.', true, false),
        getColumn(t, 'name', 'projectMasterData:measures.columns.'),
        // getColumn(t, 'massnahme_type_id', 'projectMasterData:measures.columns.'),
        getColumn(t, 'umsetzung_type_id', 'projectMasterData:measures.columns.', true, false),
        getColumn(t, 'zeitraum_type_id', 'projectMasterData:measures.columns.'),
        getColumn(t, 'bwv_stand', 'projectMasterData:measures.columns.', true, false),
        getColumn(t, 'plan_name', 'projectMasterData:measures.columns.', true, false),
        getColumn(t, 'plan_stand', 'projectMasterData:measures.columns.', true, false),
        getColumn(t, 'plan_stand_datum', 'projectMasterData:measures.columns.', true, false, ColumnObjectType.Date, t('dateformat')),
        getColumn(t, 'flaechenbezug_type_name', 'projectMasterData:measures.columns.', true, false),
        getColumn(t, 'start_datum_soll', 'projectMasterData:measures.columns.', true, true, ColumnObjectType.Date, t('dateformat')),
        getColumn(t, 'start_datum_ist', 'projectMasterData:measures.columns.', true, false, ColumnObjectType.Date, t('dateformat')),
        getColumn(t, 'ende_datum_soll', 'projectMasterData:measures.columns.', true, true, ColumnObjectType.Date, t('dateformat')),
        getColumn(t, 'ende_datum_ist', 'projectMasterData:measures.columns.', true, false, ColumnObjectType.Date, t('dateformat')));

    return temp;
};

export const getFiltersMeasure = () => {
    return {
        ...getFilter('massnahme_type_name'),
        ...getFilter('name'),
        ...getFilter('massnahme_type_id'),
        ...getFilter('umsetzung_type_id'),
        ...getFilter('zeitraum_type_id'),
        ...getFilter('bwv_lf_nr'),
        ...getFilter('bwv_sub_lf_nr'),
        ...getFilter('bwv_stand'),
        ...getFilter('plan_name'),
        ...getFilter('plan_stand'),
        ...getFilter('plan_stand_datum'),
        ...getFilter('pfa_pgv_name'),
        ...getFilter('pfa_pgv_stand'),
        ...getFilter('pfa_pgv_datum'),
        ...getFilter('flaechenbezug_type_name'),
        ...getFilter('start_datum_soll'),
        ...getFilter('start_datum_ist'),
        ...getFilter('ende_datum_soll'),
        ...getFilter('ende_datum_ist'),
    };
};

export interface Utilisation {
    'project_id': string,
    'flurstueck_id': string,
    'flstkennz': string,
    'inanspruchnahme_id': string,
    'inanspruchnahme_type_id': number,
    'inanspruchnahme_type_name': string,
    'verzeichnis_lf_nr': string,
    'verzeichnis_sub_lf_nr': string,
    'verzeichnis_stand': string,
    'inanspruchnahme_plan_name': string,
    'inanspruchnahme_plan_stand': string,
    'inanspruchnahme_plan_stand_datum': Nullable<Date>,
    'pfa_pgv_km_start': string,
    'pfa_pgv_km_ende': string,
    'flaeche_netto': string,
    'flaeche_verzeichnis': string,
    'flaeche_rest': string,
    'eco_werte_lf_nr': string,
    'eco_werte_punkte': string,
    'inanspruchnahme_start_datum_soll': Nullable<Date>,
    'inanspruchnahme_start_datum_ist': Nullable<Date>,
    'inanspruchnahme_ende_datum_soll': Nullable<Date>,
    'inanspruchnahme_ende_datum_ist': Nullable<Date>,
    'inanspruchnahme_massnahme_map_start_datum_soll': Nullable<Date>,
    'inanspruchnahme_massnahme_map_start_datum_ist': Nullable<Date>,
    'inanspruchnahme_massnahme_map_ende_datum_soll': Nullable<Date>,
    'inanspruchnahme_massnahme_map_ende_datum_ist': Nullable<Date>,
    'massnahme': any[],
    'expandableElement'?: any,
}

export const getColumnsUtilisation = (t: any, showMeasureInfo: boolean) => {
    const temp = [];

    temp.push(
        getColumn(t, 'verzeichnis_lf_nr', 'projectMasterData:utilisation.columns.'),
        getColumn(t, 'verzeichnis_sub_lf_nr', 'projectMasterData:utilisation.columns.'),

        getColumn(t, 'flstkennz', 'projectMasterData:utilisation.columns.'),
        getColumn(t, 'inanspruchnahme_type_name', 'projectMasterData:utilisation.columns.'),
        getColumn(t, 'verzeichnis_stand', 'projectMasterData:utilisation.columns.', true, false),
        getColumn(t, 'inanspruchnahme_plan_name', 'projectMasterData:utilisation.columns.', true, false),
        getColumn(t, 'inanspruchnahme_plan_stand', 'projectMasterData:utilisation.columns.', true, false),
        getColumn(t, 'inanspruchnahme_plan_stand_datum', 'projectMasterData:utilisation.columns.', true, false, ColumnObjectType.Date, t('dateformat')),
        getColumn(t, 'pfa_pgv_km_start', 'projectMasterData:utilisation.columns.', true, false),
        getColumn(t, 'pfa_pgv_km_ende', 'projectMasterData:utilisation.columns.', true, false),
        getColumn(t, 'flaeche_netto', 'projectMasterData:utilisation.columns.', true, false),
        getColumn(t, 'flaeche_verzeichnis', 'projectMasterData:utilisation.columns.', true, true),
        getColumn(t, 'flaeche_rest', 'projectMasterData:utilisation.columns.', true, false),
        getColumn(t, 'eco_werte_lf_nr', 'projectMasterData:utilisation.columns.', true, false),
        getColumn(t, 'eco_werte_punkte', 'projectMasterData:utilisation.columns.', true, false),
        getColumn(t, 'inanspruchnahme_start_datum_soll', 'projectMasterData:utilisation.columns.', true, true, ColumnObjectType.Date, t('dateformat')),
        getColumn(t, 'inanspruchnahme_start_datum_ist', 'projectMasterData:utilisation.columns.', true, false, ColumnObjectType.Date, t('dateformat')),
        getColumn(t, 'inanspruchnahme_ende_datum_soll', 'projectMasterData:utilisation.columns.', true, true, ColumnObjectType.Date, t('dateformat')),
        getColumn(t, 'inanspruchnahme_ende_datum_ist', 'projectMasterData:utilisation.columns.', true, false, ColumnObjectType.Date, t('dateformat')),
        getColumn(t, 'inanspruchnahme_massnahme_map_start_datum_soll', 'projectMasterData:utilisation.columns.', true, false, ColumnObjectType.Date, t('dateformat')),
        getColumn(t, 'inanspruchnahme_massnahme_map_start_datum_ist', 'projectMasterData:utilisation.columns.', true, false, ColumnObjectType.Date, t('dateformat')),
        getColumn(t, 'inanspruchnahme_massnahme_map_ende_datum_soll', 'projectMasterData:utilisation.columns.', true, false, ColumnObjectType.Date, t('dateformat')),
        getColumn(t, 'inanspruchnahme_massnahme_map_ende_datum_ist', 'projectMasterData:utilisation.columns.', true, false, ColumnObjectType.Date, t('dateformat')),);

    if (showMeasureInfo) {
        temp.push({
            field: 'massnahmen',
            header: t('projectMasterData:measures.plural'),
            body: (rowData: any) => {
                if (rowData['massnahme']) {
                    return rowData['massnahme'][0] === null ? 0 : rowData['massnahme'].length;
                }
            },
            sortFunction: sortColumn,
            display: false
        },);
    }

    return temp;
};

export const getFiltersUtilisation = () => {
    return {
        ...getFilter('flstkennz'),
        ...getFilter('inanspruchnahme_type_name'),
        ...getFilter('verzeichnis_lf_nr'),
        ...getFilter('verzeichnis_sub_lf_nr'),
        ...getFilter('verzeichnis_stand'),
        ...getFilter('inanspruchnahme_plan_name'),
        ...getFilter('inanspruchnahme_plan_stand'),
        ...getFilter('inanspruchnahme_plan_stand_datum'),
        ...getFilter('pfa_pgv_km_start'),
        ...getFilter('pfa_pgv_km_ende'),
        ...getFilter('flaeche_netto'),
        ...getFilter('flaeche_verzeichnis'),
        ...getFilter('flaeche_rest'),
        ...getFilter('eco_werte_lf_nr'),
        ...getFilter('eco_werte_punkte'),
        ...getFilter('inanspruchnahme_start_datum_soll'),
        ...getFilter('inanspruchnahme_start_datum_ist'),
        ...getFilter('inanspruchnahme_ende_datum_soll'),
        ...getFilter('inanspruchnahme_ende_datum_ist'),
        ...getFilter('inanspruchnahme_massnahme_map_start_datum_soll'),
        ...getFilter('inanspruchnahme_massnahme_map_start_datum_ist'),
        ...getFilter('inanspruchnahme_massnahme_map_ende_datum_soll'),
        ...getFilter('inanspruchnahme_massnahme_map_ende_datum_ist'),
    };
};

export interface UtilisationDetails {
    'project_id': string,
    'flurstueck_id': string,
    'inanspruchnahme_id': string,
    'inanspruchnahme_type_id': number,
    'inanspruchnahme_type_name': string,
    'verzeichnis_lf_nr': string,
    'verzeichnis_sub_lf_nr': string,
    'verzeichnis_stand': string,
    'inanspruchnahme_plan_name': string,
    'inanspruchnahme_plan_stand': string,
    'inanspruchnahme_plan_stand_datum': Nullable<Date>,
    'pfa_pgv_km_start': string,
    'pfa_pgv_km_ende': string,
    'flaeche_netto': string,
    'flaeche_verzeichnis': string,
    'flaeche_rest': string,
    'eco_werte_lf_nr': string,
    'eco_werte_punkte': string,
    'inanspruchnahme_start_datum_soll': Nullable<Date>,
    'inanspruchnahme_start_datum_ist': Nullable<Date>,
    'inanspruchnahme_ende_datum_soll': Nullable<Date>,
    'inanspruchnahme_ende_datum_ist': Nullable<Date>,
    'inanspruchnahme_massnahme_map_start_datum_soll': Nullable<Date>,
    'inanspruchnahme_massnahme_map_start_datum_ist': Nullable<Date>,
    'inanspruchnahme_massnahme_map_ende_datum_soll': Nullable<Date>,
    'inanspruchnahme_massnahme_map_ende_datum_ist': Nullable<Date>,
    'massnahme': any[]
}

const getinitColumnsUtilisationDetails = (t: any): ColumnObject[] => {
    return [
        getColumn(t, 'inanspruchnahme_type_name', 'projectMasterData:utilisation.columns.'),
        getColumn(t, 'verzeichnis_lf_nr', 'projectMasterData:utilisation.columns.'),
        getColumn(t, 'verzeichnis_sub_lf_nr', 'projectMasterData:utilisation.columns.'),
        getColumn(t, 'verzeichnis_stand', 'projectMasterData:utilisation.columns.'),
        getColumn(t, 'inanspruchnahme_plan_name', 'projectMasterData:utilisation.columns.'),
        getColumn(t, 'inanspruchnahme_plan_stand', 'projectMasterData:utilisation.columns.'),
        getColumn(t, 'inanspruchnahme_plan_stand_datum', 'projectMasterData:utilisation.columns.', true, true, ColumnObjectType.Date, t('dateformat')),
        getColumn(t, 'pfa_pgv_km_start', 'projectMasterData:utilisation.columns.'),
        getColumn(t, 'pfa_pgv_km_ende', 'projectMasterData:utilisation.columns.'),
        getColumn(t, 'flaeche_netto', 'projectMasterData:utilisation.columns.'),
        getColumn(t, 'flaeche_verzeichnis', 'projectMasterData:utilisation.columns.'),
        getColumn(t, 'flaeche_rest', 'projectMasterData:utilisation.columns.'),
        getColumn(t, 'eco_werte_lf_nr', 'projectMasterData:utilisation.columns.'),
        getColumn(t, 'eco_werte_punkte', 'projectMasterData:utilisation.columns.'),
        getColumn(t, 'inanspruchnahme_start_datum_soll', 'projectMasterData:utilisation.columns.', true, true, ColumnObjectType.Date, t('dateformat')),
        getColumn(t, 'inanspruchnahme_start_datum_ist', 'projectMasterData:utilisation.columns.', true, true, ColumnObjectType.Date, t('dateformat')),
        getColumn(t, 'inanspruchnahme_ende_datum_soll', 'projectMasterData:utilisation.columns.', true, true, ColumnObjectType.Date, t('dateformat')),
        getColumn(t, 'inanspruchnahme_ende_datum_ist', 'projectMasterData:utilisation.columns.', true, true, ColumnObjectType.Date, t('dateformat')),
        getColumn(t, 'inanspruchnahme_massnahme_map_start_datum_soll', 'projectMasterData:utilisation.columns.', true, true, ColumnObjectType.Date, t('dateformat')),
        getColumn(t, 'inanspruchnahme_massnahme_map_start_datum_ist', 'projectMasterData:utilisation.columns.', true, true, ColumnObjectType.Date, t('dateformat')),
        getColumn(t, 'inanspruchnahme_massnahme_map_ende_datum_soll', 'projectMasterData:utilisation.columns.', true, true, ColumnObjectType.Date, t('dateformat')),
        getColumn(t, 'inanspruchnahme_massnahme_map_ende_datum_ist', 'projectMasterData:utilisation.columns.', true, true, ColumnObjectType.Date, t('dateformat')),
    ];
};

export const getColumnsUtilisationDetails = (t: any, showMeasureInfo: boolean) => {
    const temp = [...getinitColumnsUtilisationDetails(t)];

    if (showMeasureInfo) {
        temp.push({
            field: 'utilisation',
            header: t('projectMasterData:measures.plural'),
            body: (rowData: any) => {
                if (rowData['massnahme']) {
                    return rowData['massnahme'][0] === null ? 0 : rowData['massnahme'].length;
                }
            },
            sortFunction: sortColumn
        },);
    }

    return temp;
};

export const getFiltersUtilisationDetails = () => {
    return {
        ...getFilter('inanspruchnahme_type_name'),
        ...getFilter('verzeichnis_lf_nr'),
        ...getFilter('verzeichnis_sub_lf_nr'),
        ...getFilter('verzeichnis_stand'),
        ...getFilter('inanspruchnahme_plan_name'),
        ...getFilter('inanspruchnahme_plan_stand'),
        ...getFilter('inanspruchnahme_plan_stand_datum'),
        ...getFilter('pfa_pgv_km_start'),
        ...getFilter('pfa_pgv_km_ende'),
        ...getFilter('flaeche_netto'),
        ...getFilter('flaeche_verzeichnis'),
        ...getFilter('flaeche_rest'),
        ...getFilter('eco_werte_lf_nr'),
        ...getFilter('eco_werte_punkte'),
        ...getFilter('inanspruchnahme_start_datum_soll'),
        ...getFilter('inanspruchnahme_start_datum_ist'),
        ...getFilter('inanspruchnahme_ende_datum_soll'),
        ...getFilter('inanspruchnahme_ende_datum_ist'),
        ...getFilter('inanspruchnahme_massnahme_map_start_datum_soll'),
        ...getFilter('inanspruchnahme_massnahme_map_start_datum_ist'),
        ...getFilter('inanspruchnahme_massnahme_map_ende_datum_soll'),
        ...getFilter('inanspruchnahme_massnahme_map_ende_datum_ist'),
    };
};
